<template>
  <div class="booking-divider booking-divider-right">
    <div class="booking-content">
      <display-banner/>
      <template v-if="loading">
        <span class="inline-loader d-md-block d-none h-100"></span>
        <span class="inline-loader d-md-none d-block"></span>
      </template>
      <products-select-item v-else :id="currentPetId"
        ref="productsSelectItemRef"
        @back="handleBack"
        @next="handleNext"/>
    </div>
    <div class="fixed-buttons">
      <button class="btn btn-tertiary w-100 mr-2" @click="triggerBack">Back</button>
      <button class="btn btn-secondary w-100 ml-2" @click="triggerNext">Next</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ServiceProductCacheMixin } from '@/mixins/Booking/ServiceProductCacheMixin'
import { BreedProductCacheMixin } from '@/mixins/Booking/BreedProductCacheMixin'
import { PetProductCacheMixin } from '@/mixins/Booking/PetProductCacheMixin'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'
import DisplayBanner from './DisplayBanner.vue'
import ProductsSelectItem from './ProductsSelectItem.vue'

export default {
  name: 'ProductsSelect',
  mixins: [ServiceProductCacheMixin, BreedProductCacheMixin, PetProductCacheMixin, SiteBookingSettingMixin],
  props: {
    lastPet: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tabs: 0,
      currentTab: 0
    }
  },
  computed: {
    ...mapState('BookingUpload', [
      'selectedPets',
      'clientTypeId'
    ]),
    currentPet () {
      return this.selectedPets[this.currentTab]
    },
    currentPetId () {
      return this.currentPet ? this.currentPet.id : ''
    },
    // pricingTypeOptions:
    // 1 = Published Services Only
    // 2 = Pet Profile Price + Published Services
    // 3 = Breed Price + Published Services
    // 4 = Auto
    // 5 = Pet Profile Price Only
    petId () {
      return [2, 4, 5].includes(this.siteBookingSettingPricingType)
        ? this.currentPet?.petId || ''
        : ''
    },
    breedId () {
      return [3, 4].includes(this.siteBookingSettingPricingType)
        ? this.currentPet?.breedId || ''
        : ''
    },
    loading () {
      return this.loadingServiceProducts || this.loadingBreedProduct || this.loadingPetProduct
    }
  },
  methods: {
    refreshServiceProducts () {
      const shouldRetry = this.retryServiceProducts || !this.serviceProducts.length
      // For unregistered clients (clientTypeId === 2), always fetch services when pricing type is 5.
      if (shouldRetry && (this.siteBookingSettingPricingType !== 5 || this.clientTypeId === 2)) {
        this.tryGetServiceProducts()
      }
    },
    triggerBack () {
      this.$refs.productsSelectItemRef.back()
    },
    triggerNext () {
      this.$refs.productsSelectItemRef.next()
    },
    handleNext () {
      if (this.currentTab < this.tabs) {
        this.currentTab++
      } else {
        this.$emit('next')
      }
    },
    handleBack () {
      if (this.currentTab > 0) {
        this.currentTab--
      } else {
        this.$emit('back')
      }
    }
  },
  created () {
    this.tabs = this.selectedPets.length > 0 ? this.selectedPets.length - 1 : 0
    this.currentTab = this.lastPet ? this.selectedPets.length - 1 : 0
  },
  components: {
    'display-banner': DisplayBanner,
    'products-select-item': ProductsSelectItem
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .booking-divider-right {
    height: max-content;
    min-height: 38.5vh !important;
  }
  .booking-content {
    height: max-content;
    min-height: 28.5vh !important;
  }
}
</style>
